import { styled } from '@nykaa/ui-components';

export const MiddleSection = styled.div<{ timerColor?: string }>`
  ${({ theme }) => theme.typography.buttonSmall};
  ${({ theme }) => `
  padding-left: ${theme.spacing.spacing10};
   display: flex;
    height: auto;
    margin: 116px 0 45px;
    padding: 0 20px;
    justify-content: center;
    flex-direction: column;

  `};
`;

export const Heading = styled.div<{ timerColor?: string }>`
  ${({ theme }) => theme.typography.buttonSmall};
  ${({ theme, timerColor }) => `color: ${timerColor || theme.colors.warning};
  padding-left: ${theme.spacing.spacing10};
  padding-bottom: 32px;
   display: flex;
    justify-content: center;
    flex-direction: column;
  `};
`;

export const PartOne = styled.div<{ timerColor?: string }>`
  ${({ theme }) => theme.typography.labelSmall};
  color: #001325a3;
  align-self: center;
`;

export const PartTwo = styled.div<{ timerColor?: string }>`
  ${({ theme }) => theme.typography.titleMedium};
  color: #001325eb;
  display: flex;
  justify-content: center;
`;

export const RewardsBenefits = styled.img`
  height: 478px;
  cursor: pointer;
  box-shadow: 0 2px 4px -2px rgba(17, 19, 20, 0.12), 0 2px 8px rgba(17, 19, 20, 0.12);
  border-radius: 8px;
`;

export const RewardsBenefitsContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const RewardsBenefitsButton = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  height: 90px;
  width: 50%;
`;
